import insufficientPlaylistRightsCompiled from './insufficient-playlist-rights.hbs';
import videoNotSupportedCompiled from './video-not-supported.hbs';
import { Context } from './types';
import { TypeSafeTemplateDelegate } from '../../../Utility/Handlebars/types';

interface ErrorContext {
    announcement: {
        background_color: string;
        id: string | number;
    };
}

export const insufficientPlaylistRightsTemplate: TypeSafeTemplateDelegate<Context<ErrorContext>> =
    insufficientPlaylistRightsCompiled;
export const videoNotSupportedTemplate: TypeSafeTemplateDelegate<Context<ErrorContext>> =
    videoNotSupportedCompiled;
